"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { buildRepAvatarItems } from "./buildRepAvatarItems";
import { RateMatter } from "@/types/enums";
import { AnimatePresence, motion } from "framer-motion";
import { useContext, useMemo, useState } from "react";
import UserPageIdentityHeaderCICRate from "../identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageRepModifyModal from "./modify-rep/UserPageRepModifyModal";
import GrantRepDialog from "./new-rep/GrantRepDialog";
import type { RepDirection } from "./UserPageRep.helpers";
import { getCanEditRep, getCanEditNic } from "./UserPageRep.helpers";
import MobileTabCards from "./MobileTabCards";
import MobileRepTabContent from "./MobileRepTabContent";
import MobileIdentityTabContent from "./MobileIdentityTabContent";
type MobileTab = "rep" | "identity";
export default function UserPageRepMobile(t0) {
  const $ = _c(65);
  const {
    profile,
    overview,
    categories,
    cicOverview,
    repDirection,
    onRepDirectionChange,
    initialActivityLogParams,
    loading,
    visibleCount,
    onShowMore,
    hasNextPage,
    isFetchingNextPage
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const {
    address
  } = useSeizeConnectContext();
  const [activeTab, setActiveTab] = useState("rep");
  const [isGrantRepOpen, setIsGrantRepOpen] = useState(false);
  const [isNicRateOpen, setIsNicRateOpen] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== profile) {
    t1 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = profile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const canEditRep = t1;
  let t2;
  if ($[4] !== activeProfileProxy || $[5] !== address || $[6] !== connectedProfile || $[7] !== profile) {
    t2 = getCanEditNic({
      connectedProfile,
      targetProfile: profile,
      activeProfileProxy,
      address
    });
    $[4] = activeProfileProxy;
    $[5] = address;
    $[6] = connectedProfile;
    $[7] = profile;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const canEditNic = t2;
  let t3;
  if ($[9] !== activeProfileProxy || $[10] !== address || $[11] !== profile) {
    t3 = !activeProfileProxy && !!profile.handle && (profile.wallets ?? []).some(w => w.wallet.toLowerCase() === address?.toLowerCase());
    $[9] = activeProfileProxy;
    $[10] = address;
    $[11] = profile;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const canEditStatements = t3;
  cicOverview?.contributors.data;
  let t4;
  if ($[13] !== cicOverview?.contributors.data) {
    t4 = buildRepAvatarItems(cicOverview?.contributors.data ?? [], 3, {
      omitHref: true
    });
    $[13] = cicOverview?.contributors.data;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const cicAvatarItems = t4;
  let t5;
  if ($[15] !== activeTab || $[16] !== cicAvatarItems || $[17] !== cicOverview || $[18] !== overview || $[19] !== profile || $[20] !== repDirection) {
    t5 = <MobileTabCards activeTab={activeTab} onTabChange={setActiveTab} overview={overview} cicOverview={cicOverview} profile={profile} repDirection={repDirection} cicAvatarItems={cicAvatarItems} />;
    $[15] = activeTab;
    $[16] = cicAvatarItems;
    $[17] = cicOverview;
    $[18] = overview;
    $[19] = profile;
    $[20] = repDirection;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== activeTab || $[23] !== canEditNic || $[24] !== canEditRep || $[25] !== canEditStatements || $[26] !== categories || $[27] !== cicOverview || $[28] !== hasNextPage || $[29] !== initialActivityLogParams || $[30] !== isFetchingNextPage || $[31] !== loading || $[32] !== onRepDirectionChange || $[33] !== onShowMore || $[34] !== overview || $[35] !== profile || $[36] !== repDirection || $[37] !== visibleCount) {
    t6 = <AnimatePresence mode="wait">{activeTab === "rep" ? <motion.div key="rep" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}><MobileRepTabContent profile={profile} overview={overview} categories={categories} repDirection={repDirection} onRepDirectionChange={onRepDirectionChange} initialActivityLogParams={initialActivityLogParams} loading={loading} canEditRep={canEditRep} visibleCount={visibleCount} onShowMore={onShowMore} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} onGrantRep={() => setIsGrantRepOpen(true)} onEditCategory={setEditCategory} /></motion.div> : <motion.div key="identity" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}><MobileIdentityTabContent profile={profile} cicOverview={cicOverview} initialActivityLogParams={initialActivityLogParams} canEditNic={canEditNic} canEditStatements={canEditStatements} onRateNic={() => setIsNicRateOpen(true)} /></motion.div>}</AnimatePresence>;
    $[22] = activeTab;
    $[23] = canEditNic;
    $[24] = canEditRep;
    $[25] = canEditStatements;
    $[26] = categories;
    $[27] = cicOverview;
    $[28] = hasNextPage;
    $[29] = initialActivityLogParams;
    $[30] = isFetchingNextPage;
    $[31] = loading;
    $[32] = onRepDirectionChange;
    $[33] = onShowMore;
    $[34] = overview;
    $[35] = profile;
    $[36] = repDirection;
    $[37] = visibleCount;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsGrantRepOpen(false);
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] !== isGrantRepOpen || $[41] !== overview || $[42] !== profile) {
    t8 = <GrantRepDialog profile={profile} overview={overview} isOpen={isGrantRepOpen} onClose={t7} />;
    $[40] = isGrantRepOpen;
    $[41] = overview;
    $[42] = profile;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsNicRateOpen(false);
    $[44] = t9;
  } else {
    t9 = $[44];
  }
  let t10;
  let t11;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsNicRateOpen(false);
    t11 = () => setIsNicRateOpen(false);
    $[45] = t10;
    $[46] = t11;
  } else {
    t10 = $[45];
    t11 = $[46];
  }
  let t12;
  if ($[47] !== profile) {
    t12 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} onSuccess={t10} onCancel={t11} />;
    $[47] = profile;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== profile || $[50] !== t12) {
    t13 = <div className="tw-px-4 sm:tw-px-6"><UserPageRateWrapper profile={profile} type={RateMatter.NIC}>{t12}</UserPageRateWrapper></div>;
    $[49] = profile;
    $[50] = t12;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  let t14;
  if ($[52] !== isNicRateOpen || $[53] !== t13) {
    t14 = <MobileWrapperDialog title="Rate NIC" isOpen={isNicRateOpen} onClose={t9} tabletModal={true} maxWidthClass="md:tw-max-w-md">{t13}</MobileWrapperDialog>;
    $[52] = isNicRateOpen;
    $[53] = t13;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  let t15;
  if ($[55] !== canEditRep || $[56] !== editCategory || $[57] !== profile) {
    t15 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[55] = canEditRep;
    $[56] = editCategory;
    $[57] = profile;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== t14 || $[60] !== t15 || $[61] !== t5 || $[62] !== t6 || $[63] !== t8) {
    t16 = <div>{t5}{t6}{t8}{t14}{t15}</div>;
    $[59] = t14;
    $[60] = t15;
    $[61] = t5;
    $[62] = t6;
    $[63] = t8;
    $[64] = t16;
  } else {
    t16 = $[64];
  }
  return t16;
}